import { api, transformResponse } from './axios'

// @TODO implement REST
export const fetchSelectLists = (token: string) =>
  transformResponse(
    api.get(`/getLists`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
